import { useRecoilState } from "recoil";
import useTweetStation from "../hooks/useTweetStation";
import { aboutShownState, pomodoroShownState } from "../recoilState";
import detectTouch from "../utils/detectTouch";
import shareOnFacebook from "../utils/shareOnFacebook";
import Button from "./Button";

const hasTouch = detectTouch();

export default function RoomActions({ fullscreen, fullscreenAvailable }) {
  const [pomodoroShown, setPomodoroShown] = useRecoilState(pomodoroShownState);
  const [aboutShown, setAboutShown] = useRecoilState(aboutShownState);

  const tweetStation = useTweetStation();

  function handlePomodoroClick() {
    setPomodoroShown(!pomodoroShown);
    setAboutShown(false);
  }

  function handleAboutClick() {
    setAboutShown(!aboutShown);
    setPomodoroShown(false);
  }

  return (
    <div id="horizontal">
      {fullscreenAvailable && (
        <Button
          className="hide-small-screen"
          tooltip="Fullscreen"
          icon={fullscreen.active ? "fullscreenExit" : "fullscreenEnter"}
          onClick={() =>
            fullscreen.active ? fullscreen.exit() : fullscreen.enter()
          }
          style={{ marginRight: "14px" }}
        />
      )}
      {!hasTouch && (
        <Button
          tooltip="Facebook"
          icon="facebook"
          onClick={shareOnFacebook}
          style={{ marginRight: "14px" }}
        />
      )}
      <Button
        tooltip="Tweet"
        icon="twitter"
        onClick={tweetStation}
        style={{ marginRight: "14px" }}
      />
      <Button
        tooltip="Pomodoro Timer"
        icon="timer"
        onClick={handlePomodoroClick}
        style={{ marginRight: "14px" }}
      />
      <Button tooltip="About" icon="heart" onClick={handleAboutClick} />
    </div>
  );
}
